import type { CNSConversation } from "@/models/cns";
import {
  getConversationRowMeta,
  sessionStatusDotClass,
  type ConversationSessionStatus,
} from "@/lib/conversationRowMeta";

export type { ConversationSessionStatus };

export interface RailRecentMetaInput
  extends Pick<CNSConversation, "attentionHint" | "currentStage" | "lastAgentActionLine"> {}

export interface RailRecentMeta {
  sessionStatus: ConversationSessionStatus;
  secondaryLine: string | null;
  secondaryLineFull: string | null;
}

/**
 * Derives compact rail secondary text and session status for a recent conversation row.
 * Priority: attentionHint → local running → currentStage → lastAgentActionLine.
 */
export function getRailRecentMeta(
  conversation: RailRecentMetaInput,
  opts?: { isRunningLocally?: boolean },
): RailRecentMeta {
  const meta = getConversationRowMeta(conversation, {
    isRunningLocally: opts?.isRunningLocally ?? false,
    hasNextStep: false,
    secondaryLineMax: 48,
  });
  return {
    sessionStatus: meta.sessionStatus,
    secondaryLine: meta.secondaryLine,
    secondaryLineFull: meta.secondaryLineFull,
  };
}

export { sessionStatusDotClass };
